/**
 * @file asset-download-page.js
 */
(function($) {
  'use strict';

  if ($('body').hasClass('page-node-type-document')) {
    $(document).ajaxComplete(function(event, xhr, settings) {
      const $form = $('.asset-download-success-message');
      if ( $form.length ) {
        let assetLink = $(document).find("[id=hfFormAsset]").val();
        $form.find('.webform-confirmation__message').append(
          '<p style="margin-top: 15px;"><a class="button--red" href="' + assetLink + '" target="_blank">Download</a></p>'
        );
      }
    });
  }

})(jQuery);
